import React, { useEffect, useState } from "react";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import { Box, Slide } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { fetchWalletsById } from "../../redux/state/walletsReduser/wallets.fetch";
import { selectWalletsDetails } from "../../redux/state/walletsReduser/wallets.selectors";
import { createOrderThunk } from "../../redux/state/orders/orders.fetch"; 
import PaymentForm from "../PaymentForm/PaymentForm";
import ConfirmationDialog from "../ConfirmationDialog/ConfirmationDialog";
import paymentDetailsStyles from "./PaymentDetails.styles";  

function PaymentDetails() {
  const location = useLocation();
  const { createOrderData } = location.state || {}; 
  const { idWallet } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  

  const walletByIdData = useSelector(selectWalletsDetails);
  const [isVisible, setIsVisible] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);

  useEffect(() => {
    setIsVisible(true);
    dispatch(fetchWalletsById(idWallet)); 
  }, [idWallet, dispatch]);

  const handleCreateOrder = () => {
    const orderData = {
      productName: createOrderData?.name,
      weight: createOrderData?.weight,
      district: createOrderData?.district,
      price: createOrderData?.price,
      paymentMethod: walletByIdData?.name || "Не указан", 
      wallet: walletByIdData?.wallet || "Не указан", 
    };

    dispatch(createOrderThunk(orderData)).then((response) => {
      if (response && response.payload._id) {
        navigate(`/orders/${response.payload._id}`);
      }
    });
  };

  const handleDialogOpen = () => setOpenDialog(true); 
  const handleDialogClose = () => setOpenDialog(false);

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <Slide direction="left" in={isVisible} timeout={500}>
        <Box sx={paymentDetailsStyles.box}>
          <PaymentForm handleDialogOpen={handleDialogOpen} />
        </Box>
      </Slide>

      <ConfirmationDialog 
        open={openDialog} 
        onClose={handleDialogClose} 
        onConfirm={handleCreateOrder} 
      />
    </Box>
  );
}

export default PaymentDetails;
